import request from "../../../axios";
import { getInitialSponsorInformationData } from "./type";
export const getInitialSponsorInformation = async () => {
    const { data }: { data: getInitialSponsorInformationData } = await request.get('/api/v2/notification/initial-sponsor')
    return data
}